<div
  class="data-main-content"
  id="data-main-content"
  fxLayout="row"
  fxLayoutAlign="space-between"
  fxLayoutGap="18px"
  (swiperight)="backSwipe()"
  (swipeleft)="forwardSwipe()"
>
  <div class="arrow" fxLayout="row" fxLayoutGap="24px" fxLayoutAlign="center center">
    <evc-nav-button
      [disabled]="!isBackImage || !isLoadedImg || isPreviewReport"
      [rightIcon]="leftArrowIcon"
      type="cta"
      variant="round"
      (click)="changeIndex(true)"
      size="sm"
    >
    </evc-nav-button>
  </div>

  <div fxLayout="column" class="dialog-container" fxLayoutGap="10px">
    <div fxLayout="row" class="inspection-image-div">
      <div fxLayoutAlign="center center" class="img-div">
        <div fxLayoutAlign="center center" class="img-div">
          <img *ngIf="isLoadedImg && !isVideoContent" id="displayImg" class="display-insp-img" alt="" src="{{ inspectionImage?.filePath }}" />

          <video *ngIf="isLoadedImg && isVideoContent" id="displayVideo" class="display-insp-img" controls [src]="inspectionImage?.filePath"></video>
          <mat-spinner *ngIf="!isLoadedImg" mode="indeterminate"></mat-spinner>
        </div>
      </div>

      <div fxLayoutAlign="end" fxLayout="column" class="data-div" id="data-area">
        <!--location-->
        <mat-form-field class="data-form">
          <mat-label class="top-label">{{ getPlaceholder("imageDataEdit.location" | translate) }}</mat-label>
          <mat-select [formControl]="locationControl" (selectionChange)="changeSubjectLocation()">
            <mat-option [value]="location.identifier" *ngFor="let location of locations">
              {{ location.identifier }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!--mark-->
        <mat-form-field class="data-form">
          <mat-label class="top-label">{{ getPlaceholder(markLabel) }}</mat-label>
          <mat-select [formControl]="markControl" (selectionChange)="changeMarkForm()">
            <mat-select-trigger>
              <ng-container *ngIf="markControl.value !== null">
                <mat-icon class="mark-icon" [style.color]="marks && 0 < marks.length && getMarkById(markControl.value).color"> lens</mat-icon>
                {{ marks && 0 < marks.length ? getMarkById(markControl.value).label : "" }}
              </ng-container>
            </mat-select-trigger>
            <ng-container *ngFor="let mark of marks">
              <mat-option [value]="mark.identifier" *ngIf="!isMarkDisabled(mark.color)">
                <mat-icon class="mark-icon" [style.color]="mark.color">lens</mat-icon>
                {{ mark.label }}
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>

        <!--title-->
        <app-search-combo-box
          class="data-form"
          width="320"
          [options]="titleOptions"
          [placeholder]="getPlaceholder(titleLabel)"
          [disabled]="!isEditable"
          (changedValue)="onTitleChange($event)"
          [selectedId]="titleControl.getRawValue()"
        >
        </app-search-combo-box>

        <!--tags-->
        <mat-form-field *ngIf="isShowTags" class="data-form">
          <mat-label>{{ getPlaceholder(tagsLabel) }}</mat-label>
          <mat-select multiple [formControl]="tagsControl" (selectionChange)="changeTagFrom()">
            <mat-option [value]="tag" *ngFor="let tag of tags">
              {{ tag }}
            </mat-option>
          </mat-select>
          <!--Merry tags the tag list has no tag for-->
          <mat-icon
            *ngIf="unmatchedTags.length"
            matSuffix
            class="unmatched-tags-icon"
            [matTooltip]="'imageDataEdit.unmatchedTags' | translate: { tags: unmatchedTags.join(', ') }"
            >info_outline</mat-icon
          >
        </mat-form-field>

        <mat-form-field class="data-form">
          <mat-label class="top-label">{{ getPlaceholder("imageDataEdit.adoptedImage" | translate) }}</mat-label>
          <mat-select [formControl]="usedImageModeControl" (selectionChange)="toggleUseModifiedImage()">
            <mat-option [value]="UseImageType.ORIGINAL">{{ "imageDataEdit.original" | translate }}</mat-option>
            <mat-option [value]="UseImageType.RETOUCHED" *ngIf="inspectionImage && inspectionImage.hasModifiedImage">{{
              "imageDataEdit.retouch" | translate
            }}</mat-option>
            <mat-option [value]="UseImageType.REMEASUREMENT" *ngIf="inspectionImage && inspectionImage.hasMeasurementImage">{{
              "imageDataEdit.remeasurement" | translate
            }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="comment-form">
          <mat-label>{{ getPlaceholder("imageDataEdit.comment" | translate) }}</mat-label>
          <textarea
            matInput
            maxlength="{{ commentMaxLength }}"
            [formControl]="commentControl"
            style="width: 100%"
            (change)="changeCommentForm()"
            rows="4"
          >
          </textarea>
          <mat-hint align="end">{{ commentControl.value?.length || 0 }}/{{ commentMaxLength }}</mat-hint>
          <mat-error *ngIf="commentControl.hasError('maxlength')">
            {{ "imageDataEdit.commentMaxLengthError" | translate: { commentMaxLength: commentMaxLength } }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="arrow" fxLayout="column" fxLayoutAlign="center center">
    <evc-nav-button
      [disabled]="!isForwardImage || !isLoadedImg || isPreviewReport"
      [rightIcon]="rightArrowIcon"
      type="cta"
      variant="round"
      (click)="changeIndex(false)"
      size="sm"
    />
  </div>
</div>
